var SliderInput = function(el) {
  var obj = this;
    this.$t = $(el); //slider dom container

    this.textInput = this.$t.closest('label').find('.hasSlider');
    this.textValue = this.textInput.attr('value');
    this.minVal = parseNum(stripTxtToNumber(this.textInput.attr('min')), obj, 0);
    this.maxVal = parseNum(stripTxtToNumber(this.textInput.attr('max')), obj, 0);
    this.decimals = parseNum(stripTxtToNumber(this.textInput.attr('decimals')), obj, 0);
    this.value = this.textValue != '' ? parseNum(stripTxtToNumber(this.textValue), obj, 0) : this.minVal;
    this.unit = this.textInput.attr('unit');
    var stepText = stripTxtToNumber(this.textInput.attr('step'));
    if(stepText.indexOf(',') < 0 && stepText.indexOf('.') < 0) {
      this.sliderStep = parseNum(stepText);
    } else {
      this.sliderStep = parseFloat(stepText);
    }
    this.$t.noUiSlider({
      range: {
	'min': this.minVal,
	'max': this.maxVal
      },
      start: this.value,
      step: this.sliderStep,
      format: wNumb({
	decimals: this.decimals,
	thousand: '',
	postfix: '',
      })
    });
    this.$t.on('slide', function(){
      var obj = $(this).data('sliderInput');
      obj.value = $(this).val();
      obj.updateTextValue(obj);
      obj.textInput.focus().blur(); //hack for ie

      creditCalculator.calculate(obj);
    });

    function isInt(n) {
      return n % 1 === 0;
    }

    this.updateTextValue = function(obj) {
      obj.textValue =creditCalculator.formatTextValue(obj.value, obj.unit);
      obj.textInput[0].value = obj.value == 0 ? '' :  obj.textValue;
      unmarkField(obj.textInput);
    };

    this.textInput.change(function(){
      var inp = $(this);
      var obj = inp.closest('label').find('.ccalc-slider').data('sliderInput');
    var value = parseNum(stripTxtToNumber(inp.val().split(obj.unit)[0]), obj);
    if(+obj.sliderStep && obj.sliderStep === (obj.sliderStep|0)) {
      value = value.toFixed();
    }
    //check limits
      if(value > obj.maxVal) {
	obj.value = obj.maxVal;
      } else if (value < obj.minVal) {
	obj.value = obj.minVal;
      } else {
	obj.value = isInt(value) ? value : value.toFixed(2);
      }
      obj.slider = obj.$t.val(value);
      obj.updateTextValue(obj);
      creditCalculator.calculate(obj);
    });

    function stripTxtToNumber(txt) {
      return txt.replace(/\s/g, "").replace(/,/g, '.').replace(/[^0-9.-]/g, '');
    }

    function parseNum(txt, obj, defaultVal) {
      var value = parseFloat(txt);
    if(isNaN(value)) {
      return defaultVal ? defaultVal : obj.minVal;
    }
    return  value;
    }

};

var CreditCalculator = function (locale) {
  var cc = this;
    cc.hints = $('.ccalc-fieldhint');
    var sliders = $('.ccalc-slider');
    var secondPersonEls = $('.secondPerson');
    cc.step = 1;
    cc.form = $('#creditCalculator');
    cc.locale = locale;
    cc.swedish = cc.locale == 'Sweden';
    cc.sliderInputs = {};
    cc.monthlyCostInp = cc.form.find('[name=monthlyCost]');
    cc.totalCostInp = cc.form.find('[name=totalCost]');
    cc.amortisationInp = cc.form.find('[name=amortisation]');
    cc.totalCreditCostInp = cc.form.find('[name=totalCreditCost]');
    cc.periodMonthsInp = cc.form.find('[name=periodMonths]');
    cc.effectiveInterestInp = cc.form.find('[name=effectiveInterest]');
    if(cc.swedish) {
      cc.propertyCostInp = cc.form.find('[name=propertyCost]');
      cc.downPaymentInp = cc.form.find('[name=downPayment]');
    }
    cc.totalInp = cc.form.find('.ccalc-resultbox__num');
    cc.toFixedLocalized = function(number, fractionLength) {
      return (parseFloat(number).toFixed(fractionLength) + '').replace('.', cc.delimiter);
    };
    cc.fractionLength = 2;
    cc.delimiter = ',';
    cc.setHints = function() {
    cc.hints.each(function(){
	var $t = $(this);
	$t.position({
      my: 'left center',
      at: 'right+5 center',
      of: $t.prev('.ccalc-hashint')
	});
    });
    cc.form.find('.ccalcst2form .fieldErrorMessage').each(function(){
      var $t = $(this);
      var $closestInp = $t.closest('.ccalcst2__fieldsrow').find('[name="' + $t.closest('label').attr('for') + '"]');
	$t.position({
	my: 'left bottom',
	at: 'left top-2',
	of: $closestInp
	});
    });
    };
    cc.placeholderInputs = cc.form.find(':input[placeholder]');

    cc.formatTextValue = function(value, unit, noSpace) {
      var result = ("" + value).replace(/\./, ',');
      if(noSpace == undefined) {
	result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    return result + (unit !== undefined ? unit : '');
    };

    cc.calculate = function(sliderInput) {
      if (cc.swedish && sliderInput.textInput.attr('name') == 'propertyCost') {
	var value = parseInt(cc.sliderInputs.propertyCost.value);
	var downPaymentSliderInputObj = cc.sliderInputs.downPayment;
	var quarter = value/4;
	updateSliderRange(downPaymentSliderInputObj.$t, quarter, value, quarter);
	cc.downPaymentInp.val(cc.formatTextValue(quarter, cc.downPaymentInp.attr('unit')));
	// downPaymentSliderInputObj.minVal = quarter;
	// downPaymentSliderInputObj.maxVal = value;
	// downPaymentSliderInputObj.$t.slider('option', 'min', quarter);
	// downPaymentSliderInputObj.$t.slider('option', 'max', value);
	// downPaymentSliderInputObj.$t.slider('value', quarter);
      } else {
	var sum = parseInt(cc.sliderInputs.ccalc_sum.value);
	var percent = cc.sliderInputs.ccalc_percent.value/100;
	var period = parseInt(cc.sliderInputs.ccalc_period.value);
	if(sum == 0 || percent == 0 || period == 0) {
	  cc.totalInp.html('0');
	  cc.monthlyCostInp.val('');
	  cc.totalCostInp.val('');
	  cc.amortisationInp.val('');
	  cc.effectiveInterestInp.val('');
	  cc.totalCreditCostInp.val('');
	  cc.periodMonthsInp.val('');
	  return;
	}
	cc.monthlyCost = (sum*percent/12);
	//console.log("Sum: " + sum);
	//console.log("Percent: " + percent);
	//console.log("Monthly cost: " + cc.monthlyCost);
	cc.monthlyCostInp.val(cc.formatTextValue(cc.toFixedLocalized(cc.monthlyCost, cc.fractionLength), cc.monthlyCostInp.attr('unit')));
	cc.periodMonths = period*12;
	cc.periodMonthsInp.val(cc.formatTextValue(cc.periodMonths, cc.periodMonthsInp.attr('unit')));
	cc.total = (sum*( ( percent/12*Math.pow((1+percent/12), cc.periodMonths) ) / ( Math.pow(1+percent/12, cc.periodMonths)-1 ) )).toFixed(2);
	//console.log("Total monthly: " + cc.total);
	var totalTxt = cc.formatTextValue(cc.toFixedLocalized(cc.total, cc.fractionLength));
	cc.totalInp.html(totalTxt);
	cc.form.find("[name='ccalc_total']").val(totalTxt);
	cc.totalCost = (cc.periodMonths * cc.total - sum).toFixed(2);
	//console.log("Total cost: " + cc.totalCost);
	cc.totalCostInp.val(cc.formatTextValue(cc.toFixedLocalized(cc.totalCost, cc.fractionLength), cc.totalCostInp.attr('unit')));
	cc.amortisation = (cc.total - cc.monthlyCost).toFixed(2);
	cc.amortisationInp.val(cc.formatTextValue(cc.toFixedLocalized(cc.amortisation, cc.fractionLength), cc.amortisationInp.attr('unit')));
	cc.totalCreditCost = parseFloat(sum)+parseFloat(cc.totalCost);
	cc.totalCreditCostInp.val(cc.formatTextValue(cc.totalCreditCost.toFixed(2), cc.totalCreditCostInp.attr('unit')));
	cc.effectiveInterest = (Math.pow(1+percent/cc.periodMonths, cc.periodMonths)-1)*100;
	//console.log("Effective interest: " + cc.effectiveInterest);
	cc.effectiveInterestInp.val(cc.formatTextValue(cc.toFixedLocalized(cc.effectiveInterest, cc.fractionLength), cc.effectiveInterestInp.attr('unit'), true));
      }
    };

    function init(){
    if (cc.step == 2 && cc.form.peopleNum[1].checked) {
	toggleSecondPerson(true);
    }

    if ($('.errStep').length > 0) {
      gotoStep(2);
    }

    //if telephone fields have error
    $('.telFields .errorField').each(function(){
      var $t = $(this);
      if(!$t.attr('disabled')) {
	var errMess = $(this).closest('td.telFields').prev('td').find('label .fieldErrorMessage');
	if(errMess.is(':hidden')) {
	  errMess.css('display', 'block');
	}
      }
    });

    cc.form.find('[name=peopleNum]').change(function(){
	toggleSecondPerson();
    });


    cc.setHints();

    // Form reset
    cc.form.find('.ccalcstep1-reset').click(function(){
	$(document).trigger('formReset');
	sliders.each(function(){
	  $(this).val(0);
	});
	cc.totalInp.html('0');
	cc.monthlyCost = 0;
	cc.total = 0;
	cc.totalCost = 0;
	cc.amortisation = 0;
	cc.totalCreditCost = 0;
	cc.periodMonths = 0;
	cc.effectiveInterest = 0;
	if(cc.swedish) {
	  cc.downPayment = 0;
	  cc.propertyCost = 0;
	}
	for (var iName in cc.sliderInputs) {
	  var inp = cc.sliderInputs[iName];
	  inp.value = inp.minVal;
	  inp.textInput[0].value = '';
	}
    });

    // First step fake submit
    cc.form.find('.ccalcstep1-submit').click(function(){
      var $t = $(this);
      var errors = false;
      for (var key in cc.sliderInputs) {
	//console.log('value:'+cc.sliderInputs[key].value+', length:' + cc.sliderInputs[key].value.length);
	if (cc.sliderInputs[key].value == 0 || cc.sliderInputs[key].value == undefined || cc.sliderInputs[key].value == null) {
	  markField(cc.sliderInputs[key].textInput);
	  errors = true;
	}
      }
      if (errors) {
	scrollToElement('.calculator-block__content');
	return false;
      }
      cc.form.submit();
      // cc.form.submittype = $t.attr('submittype');
      // cc.form.find('.ccalcst2__titlerow').first().find('td').html($t.text());
      // gotoStep(2);
      // //google analytics
      // ga('send', 'event', 'Credit calculator form ' + cc.locale, 'Step 1 submit');
    });

    // Back from second to first step
    // cc.form.find('.ccalc_backButton').click(function(){
    //     gotoStep(1);
    // });

    //Result submit
    // cc.form.find('.ccalc_submit').click(function(){
    //   cc.form.find('[name=submittype]')[0].value = cc.form.submittype;
    //   var rateObj = cc.sliderInputs['ccalc_percent'];
    //   if(rateObj.textInput.val() == 0) {
    //     rateObj.textInput.val(creditCalculator.formatTextValue(rateObj.minVal, rateObj.unit));
    //   }
    //   var periodObj = cc.sliderInputs['ccalc_period'];
    //   if(periodObj.textInput.val() == 0) {
    //     periodObj.textInput.val(creditCalculator.formatTextValue(periodObj.minVal, periodObj.unit));
    //   }

    //   ga('send', 'event', 'Credit calculator form ' + cc.locale, 'Step 2 submit');
    //     cc.form.submit();
    // });

    //attach sliders
    var toCalc = true;
    sliders.each(function(){
      var sliderInput = new SliderInput(this);
      $(this).data('sliderInput', sliderInput);
      cc.sliderInputs[sliderInput.textInput.attr('name')] = sliderInput;
      if(sliderInput.value == 0) toCalc = false;
    });

    if (toCalc) cc.calculate();


      var step2TitleRows = $('.ccalcst2__titlerow');

      step2TitleRows.prev('.ccalcst2__fieldsrow').not('.lastrow').addClass('lastrow');

      step2TitleRows.next('.ccalcst2__fieldsrow').not('.firstrow').addClass('firstrow');

    }
    init();

    function gotoStep(step) {
      $('#contentLayout').toggleClass('ccalc_state2', step == 2);
      cc.step = step;
      cc.setHints();
    }

    function toggleSecondPerson(on){
      secondPersonEls.each(function(){
      var $t = $(this);
      if($t.attr('type')) { //toggling "disabled" attribute on form controls
        this.disabled = on ? !on : !this.disabled;
        unmarkField($t);
      } else {//styling font for labels and titles
        if (on) {
          $t.toggleClass('disabled', !on);
        } else {
          $t.toggleClass('disabled');
        }
      }

    });
  }
};

jQuery.extend({
  random: function(X) {
    return Math.floor(X * (Math.random() % 1));
  },
  randomBetween: function(MinV, MaxV) {
    return MinV + jQuery.random(MaxV - MinV + 1);
  }
});

window.trackUnload = false;

var langSubmit = function(locale) {
  var coo = $.cookie("aland_fi_lang");
  if (locale != coo) {
    $.cookie("aland_fi_lang", locale, {path: '/', expires: 18250}); /* 50 years that is infinity */
    var form = document.forms.selectLanguage;
    form.action = '/info/opencms/Finland/' + locale.split('_')[0] + '/';
    form.submit();
  }
};

var switchLanguage = function (locale) {
  var coo = $.cookie("aland_fi_lang");
  if (locale != coo) {
    $.cookie("aland_fi_lang", locale, {path: '/', expires: 18250});
  }
  return true;
};

var updateSliderRange = function($slider,min,max,value) {
    value = (value)? value : min; // default to min if unspecified
    $slider.noUiSlider({
      range: {
	'min': min,
	'max': max
      },
      start: value,
    }, true);
};

var creditCalculator;

$(document).ready(function() {


  if ($('#creditCalculator').length > 0) {
    creditCalculator = new CreditCalculator('Sweden'); // TODO Add the real current locale here
  }


  var keywordsTrigger = $("#keywords");

  var submenuLinksNotCurrent = $("#subMenu a:not(.current)");
  var submenuCurrentLink = $("#subMenu .current");

  $("#keywordsTrigger").click(function(){
    keywordsTrigger.toggle();
  });

  $(window).unload(function(){
    checkUnload();
  });

  $('.duplicate-slider').on('set', function(){
    var $this = $(this);
    var thisVal = $this.val();
    var thisTarget = $this.data('target');
    var obj = $(thisTarget).data('sliderInput');
    obj.value = thisVal;
    obj.updateTextValue(obj);
    $(thisTarget).val(thisVal);
    creditCalculator.calculate(obj);
  });


  $(document).on('formReset', function() {
    $.each($('.duplicate-slider'), function() {
      var $this = $(this),
	thisVal = 0,
	obj = $(this).data('sliderInput');
	obj.value = thisVal;
	obj.updateTextValue(obj);

      $(this).val(thisVal);
      creditCalculator.calculate(obj);
    });
  });

});


function markField (fieldObj) {
  fieldObj.addClass("errorField");
  if (fieldObj.data("label") && fieldObj.data("errorMessage")) {
    fieldObj.data("errorMessage").css("display", "inline");
  } else {
    fieldObj.closest('label').find('.fieldErrorMessage').css('display', 'inline');
  }
}

function unmarkField (fieldObj) {
  var ccalcCheck = fieldObj.closest('tr.ccalcst2__fieldsrow');
  fieldObj.removeClass("errorField");
  var errObj;
  if (fieldObj.data("label") && fieldObj.data("errorMessage")) {
    errObj = fieldObj.data("errorMessage");
  } else if(ccalcCheck.length > 0) {
    errObj = fieldObj.closest('td').prev('td').find('.fieldErrorMessage');
  } else {
    errObj = fieldObj.closest('label').find('.fieldErrorMessage');
  }
  if(errObj.length > 0) {
    errObj.css('display', 'none');
  }
}

function checkUnload() {
 if (window.trackUnload == true) {
   var inputs = $(".accordion a.ui-state-active").next().find("form input[type='text'],textarea,select");
   for (i = 0; i < inputs.size(); i++) {
    field = inputs.get(i);
    if (field.value == "") continue;
    label = $(".accordion a.ui-state-active").next().find("form label[for='" + field.name + "']");
    ga('send', 'event', 'Contact form Åland Islands', 'Non-submitted field value', 'Field: ' + label.get(0).childNodes[0].textContent + ', value: ' + field.value.replace(/'/g,''),0,{'nonInteraction': 1});
  }
  ga('send', 'event', 'Contact form Åland Islands', 'Abandonment', $(".accordion a.ui-state-active").text(),0, {'nonInteraction': 1});
}
}
